<template>


    <div class="peripheral-detail-container">
        <div class="title-container">
            <van-image
                    @click="back"
                    width="36px"
                    height="36px"
                    fit="fit"
                    :src="backIcon"/>
            <span class="title">Name: {{deviceInfo.name}}</span>
        </div>

        <div v-for="(item,key,index) in peripheralInfo" :key="key" class="service-container">
            <div class="service-title">{{serviceName(key)}}</div>
            <div class="service-uuid">UUID:{{key}}</div>
            <div class="characteristic-container">
                <div class="characteristic-item" v-for="characteristic in item" :key="characteristic.uuid"
                     @click="characteristicDetail(key,characteristic)">
                    <div class="item-title bt">{{characteristic.aliasName}}</div>
                    <div class="item  mt-8 fs-24">{{characteristic.data}}</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import table from "../utils/ServiceTable"
    import bluetoothRepository from "../repository/BluetoothRepository"

    export default {
        name    : "PeripheralDetail",
        data() {
            return {backIcon: require('../assets/back.png')}
        },
        methods : {
            back() {
                bluetoothRepository.disconnect()
                this.$router.back()
            },
            serviceName(uuid) {
                return table.findServiceName(uuid)
            },
            characteristicName(serviceUUID, uuid) {
                return table.findCharacteristicName(uuid)
            },
            characteristicDetail(serviceUUID, characteristic) {
                this.$router.push({
                    name  : "CharacteristicDetail",
                    params: {serviceUUID, characteristic}
                })
            }
        },
        computed: {
            deviceInfo() {
                return this.$store.state.deviceInfo
            },
            peripheralInfo() {
                return this.$store.state.peripheralInfo
            }
        }
    }
</script>

<style lang="scss" scoped>
    .peripheral-detail-container {
        display: flex;
        background: white;
        padding: 0.5rem;
        flex-direction: column;

        .title-container {
            display: flex;
            flex-direction: row;
            align-items: center;

            .title {
                font: 18px bold;
                font-weight: bolder;
                padding: 1rem 0.5rem;
            }
        }

        .service-container {
            display: flex;
            padding: 1rem 0.5rem;
            font-size: 14px;
            flex-direction: column;

            .service-title {
                font: 18px bold;
                font-weight: bolder;
            }

            .service-uuid {
                margin-top: 2px;
            }

            .characteristic-container {
                border-radius: 8px;
                background-color: antiquewhite;
                display: flex;
                flex-direction: column;

                .characteristic-item {
                    padding: 1rem 0.5rem;
                    border-bottom: 0.5px solid black;

                    .item-title {
                        word-break: break-all;
                        white-space: pre-wrap;
                        font: 16px bold;
                        font-weight: bolder;
                    }

                    .item {
                        word-break: break-all;
                        white-space: pre-wrap;
                        font: 16px normal;
                    }
                }
            }
        }
    }

    .bt {
        font-weight: bolder;
    }
</style>